export interface Tag {
  id: number;
  value: string;
  slug: string;
  createdAt: Date;
  updatedAt: Date;
}

export const tagFromResponse = (responseData: any): Tag => ({
  id: responseData.id,
  value: responseData.value,
  slug: responseData.slug,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
